// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"dd56bedb","60":"93a7f124","129":"4e8f307f","194":"ac2567bc","448":"1864235e","466":"b787e00a","641":"b2e8988c","787":"da20a40b","809":"4a5f5eb2","842":"d420e940","885":"7588dc87","899":"8583c350","947":"72557634","972":"d0de83a3"}[chunkId] + ".chunk.js";
};